export default "__VITE_ASSET__CDZEs_AP__"